import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { EMPLEADOS } from './types';

export const buscarEmpleados = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/empleados/listar`, body, config);
        await dispatch({ type: EMPLEADOS.BUSCAR, payload: res.data.empleados });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearEmpleado = (empleadoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(empleadoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/empleados/crear`, body, config);
        await dispatch({ type: EMPLEADOS.AGREGAR, payload: res.data.empleado });
        await dispatch(setAlert(res.data.msg || 'Empleado creado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarEmpleado = (empleadoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(empleadoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/empleados/editar`, body, config);
        await dispatch({ type: EMPLEADOS.EDITAR, payload: res.data.empleado });
        await dispatch(setAlert(res.data.msg || 'Empleado editado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarEmpleado = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/empleados/eliminar`, body, config);
        await dispatch({ type: EMPLEADOS.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg || 'Empleado eliminado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerEmpleado = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/empleados/detalles`, body, config);
        await dispatch({ type: EMPLEADOS.DETALLES, payload: res.data.empleado });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const perfilEmpleado = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/empleados/perfil`, body, config);
        await dispatch({ type: EMPLEADOS.PERFIL, payload: res.data.empleado });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarEmpleado = () => dispatch => {
    dispatch({ type: EMPLEADOS.LIMPIAR });
};
